// SPZ display formatter (CHR-02 / ADR-0038). The api stores SPZ canonically:
// uppercase + ALL whitespace stripped (`3bn 6702` → `3BN6702`). For DISPLAY
// only, Czech plates read with a space after the 3rd character (`3BN 6702`).
//
// **Display-only — NEVER written back.** This is applied at exactly two
// READ-ONLY surfaces (overview table SPZ column + mobile card SPZ). There is no
// detail read-only SPZ label: per ADR-0038 the detail SPZ is a
// dispatcher-editable `RegistryAutocomplete`, which intentionally binds the raw
// canonical value and is NEVER reformatted — reformatting an editable input
// would write a space back on auto-create (corrupting the canonical store).
export const formatSpzForDisplay = (
  spz: string | null | undefined,
): string => {
  if (!spz) return '';
  const s = spz.trim();
  if (s.length <= 3) return s;
  return `${s.slice(0, 3)} ${s.slice(3)}`;
};
